import { createSelector } from "reselect";

/**
 * selector to determine if patient overview supplies is enabled
 */
export const patientOverviewSuppliesEnabledSelector = createSelector(
  () => false
);
